import PageShell from "@/components/PageShell";
import PageMeta from "@/components/PageMeta";
import AdSlot from "@/components/AdSlot";
import UpgradeButton from "@/components/UpgradeButton";
import { Check, X } from "@phosphor-icons/react";

const tiers = [
  {
    name: "Free", price: "$0", period: "forever", cta: "Start sending", accent: false,
    features: [
      { ok: true, text: "Up to 100MB per file" },
      { ok: true, text: "6-digit codes & QR" },
      { ok: true, text: "Password protect" },
      { ok: true, text: "24-hour expiry" },
      { ok: false, text: "No transfer history" },
    ],
  },
  {
    name: "Pro", price: "₹699", period: "/ month", cta: "Upgrade to Pro", accent: true,
    features: [
      { ok: true, text: "Files up to 5GB" },
      { ok: true, text: "100 GB personal cloud" },
      { ok: true, text: "7-day default expiry" },
      { ok: true, text: "Full transfer history" },
      { ok: true, text: "Priority transfer speed" },
      { ok: true, text: "Custom branded links" },
    ],
  },
  {
    name: "Team", price: "$24", period: "/ month", cta: "Talk to sales", accent: false,
    features: [
      { ok: true, text: "Everything in Pro" },
      { ok: true, text: "Up to 10 seats" },
      { ok: true, text: "Audit logs" },
      { ok: true, text: "SAML SSO" },
      { ok: true, text: "Dedicated support" },
    ],
  },
];

export default function Pricing() {
  return (
    <PageShell
      eyebrow="Pricing"
      title="Simple, transparent."
      subtitle="Pay only for what you need. Cancel anytime. Free forever for casual transfers."
    >
      <PageMeta
        title="Pricing · Free forever + ₹699/month Pro"
        description="SendMe pricing — free tier with 100MB files, ₹699/month Pro with 5GB per file, 7-day expiry, 100GB personal cloud, team workspaces. Cancel anytime."
      />
      <div className="grid md:grid-cols-3 gap-6">
        {tiers.map((t) => (
          <div
            key={t.name}
            data-testid={`pricing-${t.name.toLowerCase()}`}
            className={`brut-card p-7 relative ${t.accent ? "shadow-[6px_6px_0px_#FF3366]" : ""}`}
          >
            {t.accent && (
              <div className="absolute -top-3 left-6 bg-[#FF3366] text-white text-[10px] uppercase tracking-[0.25em] px-2 py-1 font-bold">
                Most popular
              </div>
            )}
            <div className="small-caps mb-2">{t.name}</div>
            <div className="flex items-baseline gap-2 mb-6">
              <span className="text-5xl font-black tracking-tighter">{t.price}</span>
              <span className="text-black/50 text-sm">{t.period}</span>
            </div>
            <ul className="space-y-3 mb-8">
              {t.features.map((f, i) => (
                <li key={i} className="flex items-start gap-3 text-sm">
                  {f.ok ? (
                    <Check size={18} weight="bold" className="text-[#10B981] mt-0.5"/>
                  ) : (
                    <X size={18} weight="bold" className="text-black/25 mt-0.5"/>
                  )}
                  <span className={f.ok ? "" : "text-black/40"}>{f.text}</span>
                </li>
              ))}
            </ul>
            <button className={t.accent ? "btn-brut-accent w-full" : "btn-brut-ghost w-full"}>{t.cta}</button>
          </div>
        ))}
      </div>

      {/* Wire Pro tier CTA to Razorpay */}
      <ProUpgradeBlock />

      {/* Reserved ad slot — fills in once you create an AdSense ad unit and paste the slot id */}
      <AdSlot slot="" format="auto" className="max-w-3xl mx-auto" />
    </PageShell>
  );
}

function ProUpgradeBlock() {
  return (
    <div className="mt-10 brut-card p-6 max-w-2xl mx-auto text-center" data-testid="pro-upgrade-block">
      <div className="small-caps mb-2 text-[#FF3366]">Ready to upgrade?</div>
      <h3 className="text-2xl tracking-tight mb-2">Get SendMe Pro — ₹699 / month</h3>
      <p className="text-sm text-black/65 mb-5">Powered by Razorpay · UPI, cards, netbanking · cancel anytime.</p>
      <div className="max-w-xs mx-auto">
        <UpgradeButton>Pay ₹699 with Razorpay</UpgradeButton>
      </div>
    </div>
  );
}
